import { render } from "./Loads.vue?vue&type=template&id=eed1cabc&scoped=true"
import script from "./Loads.vue?vue&type=script&lang=js"
export * from "./Loads.vue?vue&type=script&lang=js"

import "./Loads.vue?vue&type=style&index=0&id=eed1cabc&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eed1cabc"]])

export default __exports__